import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Link, useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import * as MovieActions from '../../store/actions/movie';
import * as braze from '@braze/web-sdk';

import styled, {css} from 'styled-components';
import {
    useBreakpoint,
    mobileMediaQuery,
    notWebMediaQuery,
    PageBodyWrapper,
    Flex,
    colors,
    useIsWeb,
} from './../../styles';
import {isMobileDevice, useBrand, useIsCartoonito} from '../../helpers';

import BigButton from './../BigButton';
import Onboarding from './Onboarding';
import CartoonitoHeader from './CartoonitoHeader';

import {ReactComponent as CNLogo} from './../../assets/cn-logo.svg';
import Home from './../../assets/ic_cn_home.png';
import HomeSelected from './../../assets/ic_cn_home_selected.png';
import Shows from './../../assets/ic_cn_shows.png';
import ShowsSelected from './../../assets/ic_cn_shows_selected.png';
import Movies from './../../assets/popcorn_icon.svg';
import Now from './../../assets/ic_cn_onnow.png';
import NowSelected from './../../assets/ic_cn_onnow_selected.png';
import Games from './../../assets/ic_cn_games.png';
import GamesSelected from './../../assets/ic_cn_games_selected.png';
import Comics from './../../assets/ic_cn_comics.png';
import ComicsSelected from './../../assets/ic_cn_comics_selected.png';
import Search from './../../assets/ic_search2.png';
import ProfileIcon from '../../assets/ic_burger_menu.png';
import {ReactComponent as Chevron} from './../../assets/arrow.svg';
import Blob from '../Blob';
import CartoonitoParentalHeader from '../CartoonitoParentalHeader';
import {analyticsTrackAction} from '../../helpers/Analytics';
import {selectIsBadgeHidden} from '../../store/reducers';
import {ReactComponent as Close} from './../../assets/close.svg';
import DKidsHeader from './DKidsHeader';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    background-color: black;
    width: 100%;
    height: 80px;
    font-size: 32px;
    color: #fff !important;
    z-index: 100;
    top: 0;
    box-sizing: border-box;
    transition: 0.3s background ease-in-out;

    ${({transparentHeader}) =>
        transparentHeader &&
        css`
            ${notWebMediaQuery} {
                background: linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0.6) 0%,
                    rgba(0, 0, 0, 0) 100%
                );
            }
        `}
    padding: 0;

    ${({backgroundColor}) =>
        backgroundColor &&
        css`
            background: ${backgroundColor};
            ${notWebMediaQuery} {
                background: ${backgroundColor};
            }
        `}

    ${notWebMediaQuery} {
        height: 80px;
    }

    ${mobileMediaQuery} {
        padding: 16.5px 0;
    }

    ${({headerTop}) =>
        headerTop &&
        isMobileDevice() &&
        css`
            margin-top: ${headerTop || 0}px;
        `}
`;

const Wrapper = styled(PageBodyWrapper)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 80px;
    max-height: 100%;
    box-sizing: border-box;
    padding: 0 40px;

    ${mobileMediaQuery} {
        padding: 0 25px;
    }

    ${notWebMediaQuery} {
        height: 45px;
    }
`;

const MainLogo = styled.div`
    padding: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 105px;
    cursor: pointer;
`;

const ButtonsRow = styled.nav`
    height: 100%;
    width: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: auto;
    button {
        flex: 1;
    }

    ${notWebMediaQuery} {
        display: none;
    }
`;

const ChevronIcon = styled(Chevron)`
    margin-left: -7px;
    width: 28px;
    height: 28px;
    margin: 0px;

    transform: scaleX(-1);
    path {
        fill: #fff;
    }
`;

const AppHeader = ({setShowDrawerMenu, ...props}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const breakpoint = useBreakpoint();

    const isMobile = ['xs', 'mobile'].includes(breakpoint);
    const isTablet = ['sm', 'md'].includes(breakpoint);
    const isWeb = useIsWeb();

    const {t} = useTranslation();
    const pathname = props.currentPathname || history.location.pathname;

    const user = useSelector(state => state.user);
    const config = useSelector(state => state.config);
    const isCartoonito = useIsCartoonito();
    const isDKids = useBrand() === 'dkids';

    const [transparentHeader, setTransparentHeader] = useState(
        false,
        //window.pageYOffset < 64,
    );

    const [movies, setMovies] = useState(undefined);

    const movie = useSelector(state => state.movie);
    const badgeHidden = useSelector(selectIsBadgeHidden);

    useEffect(() => {
        if (
            user.catalogTenant &&
            (!movie.movies || (movie.movies && movie.movies.length <= 0))
        ) {
            dispatch(MovieActions.loadMovies());
        }

        // eslint-disable-next-line
    }, [user.catalogTenant]);

    useEffect(() => {
        if (movie.movies !== undefined) {
            setMovies(movie.movies);
        }

        // eslint-disable-next-line
    }, [movie.movies]);

    useEffect(() => {
        handleWindowScroll();
        window.addEventListener('scroll', handleWindowScroll);

        return () => {
            window.removeEventListener('scroll', handleWindowScroll);
        };

        // eslint-disable-next-line
    }, [window.location.pathname]);

    const handleWindowScroll = () => {
        /*const distanceFromTop = 56 - window.pageYOffset;

        if (isMobileDevice() && distanceFromTop > 0) {
            setHeaderTop(distanceFromTop);
        } else {
            setHeaderTop(0);
        }*/

        if (window.pageYOffset < 56) {
            //setTransparentHeader(true);
        } else {
            setTransparentHeader(false);
        }
    };

    const backHeader = () => {
        let showBackButton = false;

        if (
            history.location.pathname.indexOf('/play') >= 0 ||
            history.location.pathname.indexOf('/now/') >= 0 ||
            history.location.pathname.indexOf('/shows/') >= 0 ||
            history.location.pathname.indexOf('/comics/') >= 0
        ) {
            showBackButton = true;
        }

        return showBackButton && (isMobile || isTablet);
    };

    const trackHomeClick = () => {
        trackMenuClick('home');
    };

    const trackShowsClick = () => {
        trackMenuClick('shows');
    };
    const trackGamesClick = () => {
        trackMenuClick('games');
    };
    const trackComicsClick = () => {
        trackMenuClick('comics');
    };
    const trackFavoritesClick = () => {
        trackMenuClick('favorites');
    };

    const trackMenuClick = link => {
        //get current section
        let section = window.location.pathname.split('/')[1];
        analyticsTrackAction('main nav click', {
            section: section,
            subsection: section,
            linkname: `cnplus.com/${link}`,
            contentclickevent: '1',
            mainnavclickevent: '1',
        });
    };

    const parts = history.location.pathname.split('/');
    parts.shift(); //don't care about first item, as its a blank string

    if (history.location.pathname === '/onboarding') {
        return <Onboarding transparentHeader={transparentHeader} />;
    }
    //comics chapter header
    if (parts[0] === 'comics' && parts.length === 3) {
        return <div></div>;
    }

    if (['/parents', '/padres', '/pais'].includes(history.location.pathname)) {
        return <CartoonitoParentalHeader />;
    }

    // if (
    //     isCartoonito &&
    //     ['/cartoonito', '/programacao', '/programacion'].includes(
    //         history.location.pathname,
    //     )
    // ) {
    //     return (
    //         <CartoonitoLandingHeader
    //             position="fixed"
    //             width="100%"
    //             padding="15px"
    //             tablet
    //             desktop
    //             justifyContent="space-between"
    //             background={transparentHeader ? 'transparent' : 'black'}
    //         >
    //             <img src={CartoonitoLogo} alt="Cartoonito Logo" />
    //             <Button onClick={handleGoToCNAPP}>
    //                 {t('cartoonito.header.cnappCTA')}
    //             </Button>
    //         </CartoonitoLandingHeader>
    //     );
    // }

    if (isCartoonito) {
        return <CartoonitoHeader pathname={pathname} />;
    }

    if (isDKids) {
        return <DKidsHeader paddingTop={props.paddingTop} />;
    }

    //if in favorites and tablet or smaller, we change the header to #211921
    let bgColor = null;
    if (
        pathname === '/favourites' &&
        ['xs', 'mobile', 'sm', 'md'].includes(breakpoint)
    ) {
        bgColor = '#211921';
    }

    //if is live, return a new header with only the close button
    if (pathname.indexOf('/now/') !== -1) {
        return (
            <Flex
                position="relative"
                width="100%"
                padding="34px 53px"
                justifyContent="space-between"
                background="transparent"
            >
                <Flex margin="auto 0 auto 0">
                    <BackButton onClick={() => history.goBack()}>
                        <CloseIcon light title={t('controls.goback')} />
                        {t('controls.goback')}
                    </BackButton>
                </Flex>
            </Flex>
        );
    }

    return (
        <Container
            className="header"
            transparentHeader={transparentHeader}
            headerTop={props.paddingTop}
            backgroundColor={bgColor}
        >
            <Wrapper>
                <Blob />
                {backHeader() ? (
                    <>
                        <ChevronIcon
                            title={t('controls.goback')}
                            onClick={() => history.goBack()}
                        />
                        <SearchLink to="/search">
                            <img alt={t('search.placeholder')} src={Search} />
                        </SearchLink>
                    </>
                ) : (
                    <>
                        <MainLogo onClick={() => history.push('/')}>
                            <CNLogo
                                title="Cartoon Network"
                                aria-hidden="true"
                                width={
                                    isMobile
                                        ? '81px'
                                        : isTablet
                                        ? '77px'
                                        : '99px'
                                }
                                height={
                                    isMobile
                                        ? '48px'
                                        : isTablet
                                        ? '45px'
                                        : '58px'
                                }
                            />
                        </MainLogo>

                        {((config.btw && config.btw.enabled) ||
                            (user && user.jwtToken)) && (
                            <ButtonsRow>
                                <BigButton
                                    as={Link}
                                    active={['/', '/home'].includes(pathname)}
                                    icon={
                                        ['/', '/home'].includes(pathname)
                                            ? HomeSelected
                                            : Home
                                    }
                                    to="/home"
                                    value={t('home.title')}
                                    iconWidth="28px"
                                    iconHeight="28px"
                                    title={t('home.title')}
                                    gradient
                                    onClick={trackHomeClick}
                                />
                                <BigButton
                                    as={Link}
                                    active={pathname.indexOf('/shows') >= 0}
                                    icon={
                                        pathname.indexOf('/shows') >= 0
                                            ? ShowsSelected
                                            : Shows
                                    }
                                    to="/shows"
                                    value={t('shows.title')}
                                    iconWidth="28x"
                                    iconHeight="28px"
                                    title={t('shows.title')}
                                    gradient
                                    onClick={trackShowsClick}
                                />

                                {false && movies && movies.length > 0 && (
                                    <BigButton
                                        as={Link}
                                        active={
                                            pathname.indexOf('/movies') >= 0
                                        }
                                        icon={Movies}
                                        to="/movies"
                                        value={t('movies.title')}
                                        iconWidth="28px"
                                        iconHeight="28px"
                                        title={t('movies.title')}
                                        gradient
                                    />
                                )}
                                <BigButton
                                    as={Link}
                                    active={pathname.indexOf('/games') >= 0}
                                    icon={
                                        pathname.indexOf('/games') >= 0
                                            ? GamesSelected
                                            : Games
                                    }
                                    to="/games"
                                    value={t('games.title')}
                                    iconWidth="28px"
                                    iconHeight="28px"
                                    title={t('games.title')}
                                    gradient
                                    onClick={trackGamesClick}
                                />
                                <BigButton
                                    as={Link}
                                    active={pathname.indexOf('/now') >= 0}
                                    icon={
                                        pathname.indexOf('/now') >= 0
                                            ? NowSelected
                                            : Now
                                    }
                                    to="/now"
                                    value={t('onnow.title')}
                                    iconWidth="28px"
                                    iconHeight="28px"
                                    title={t('onnow.title')}
                                    gradient
                                />
                                <BigButton
                                    as={Link}
                                    active={pathname.indexOf('/comics') >= 0}
                                    icon={
                                        pathname.indexOf('/comics') >= 0
                                            ? ComicsSelected
                                            : Comics
                                    }
                                    to="/comics"
                                    value={t('comics.title')}
                                    iconWidth="28px"
                                    iconHeight="28px"
                                    title={t('comics.title')}
                                    gradient
                                    onClick={trackComicsClick}
                                />
                            </ButtonsRow>
                        )}

                        {isMobile || isTablet ? (
                            <RightButtonContainer>
                                <SearchLink to="/search" marginright={30}>
                                    <img
                                        alt={t('search.placeholder')}
                                        src={Search}
                                    />
                                </SearchLink>
                                <BigButton
                                    title={t('controls.profile')}
                                    minWidth="fit-content"
                                    flex="0"
                                    margin="0"
                                    iconWidth="28px"
                                    iconHeight="28px"
                                    padding="0"
                                    width="auto"
                                    icon={ProfileIcon}
                                    onClick={() => setShowDrawerMenu(true)}
                                />
                            </RightButtonContainer>
                        ) : user.jwtToken ? (
                            <RightButtonContainer>
                                <SearchLink to="/search" marginright={30}>
                                    <img
                                        alt={t('search.placeholder')}
                                        src={Search}
                                    />
                                </SearchLink>
                                <BigButton
                                    as="div"
                                    title={t('controls.profile')}
                                    minWidth="fit-content"
                                    flex="0"
                                    margin="0"
                                    iconWidth="38px"
                                    iconHeight="38px"
                                    padding="0"
                                    width="38px"
                                    icon={ProfileIcon}
                                    onClick={() => setShowDrawerMenu(true)}
                                />
                            </RightButtonContainer>
                        ) : (
                            <RightButtonContainer>
                                <SearchLink to="/search" marginright={30}>
                                    <img
                                        alt={t('search.placeholder')}
                                        src={Search}
                                    />
                                </SearchLink>
                                <BigButton
                                    as="div"
                                    title={t('controls.profile')}
                                    minWidth="fit-content"
                                    flex="0"
                                    margin="0"
                                    iconWidth="38px"
                                    iconHeight="38px"
                                    padding="0"
                                    width="38px"
                                    icon={ProfileIcon}
                                    onClick={() => setShowDrawerMenu(true)}
                                />
                                {braze.isPushSupported() &&
                                    isWeb &&
                                    !badgeHidden && <Badge />}
                            </RightButtonContainer>
                        )}
                    </>
                )}
            </Wrapper>
        </Container>
    );
};

const RightButtonContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

const SearchLink = styled(Link)`
    margin-right: ${props => props.marginright || 0}px;
    img {
        width: 41px;
        height: 41px;
    }
`;

const Badge = styled.div`
    position: absolute;
    width: 15px;
    height: 15px;
    top: 4px;
    right: 45px;
    background-color: ${colors.pink};
    border-radius: 50%;
`;

const BackButton = styled(Flex)`
    color: rgb(0, 0, 0);
    font-size: 22px;
    font-family: 'Rodger';
    font-weight: bold;
    letter-spacing: 1.22px;
`;

const CloseIcon = styled(Close)`
    margin-right: 14px;
    width: 28px;
    height: 28px;

    g {
        fill: ${({light}) => (light ? '#fff' : '#000')};
    }

    ${notWebMediaQuery} {
        width: 20px;
        height: 20px;
    }
`;

export default AppHeader;
